// Helpers for code that runs both in the browser and in the build-time
// pre-renderer (scripts/prerender.mjs), where window/localStorage don't exist.

export const isServer = typeof window === 'undefined'

export const SITE_ORIGIN = 'https://www.24shotclock.com'

export const CONTACT_EMAIL = 'contact@24shotclock.com'

// True when the page was served as pre-rendered static HTML. Evaluated once at
// module load — before React mounts — so it reflects the initial payload only.
export const isPrerendered =
  !isServer && !!document.getElementById('root')?.firstElementChild

export const currentOrigin = () => (isServer ? SITE_ORIGIN : window.location.origin)

export const storage = {
  get(key: string): string | null {
    try {
      return localStorage.getItem(key)
    } catch {
      return null
    }
  },
  set(key: string, value: string) {
    try {
      localStorage.setItem(key, value)
    } catch {}
  },
}
